import { IGaUser } from '../../types/user/gaUser';
import { TUser } from '../../types/user/user';
import { NOT_AUTHORIZED_GA_USER } from '../../constants';
import { ELkType } from '../../repositories/lk-type/entities/get_lk_type_v2/GetLkTypeResponseV2';

export function createGaUser(user: TUser, lkType: ELkType | null): IGaUser {
  if (!user) {
    return NOT_AUTHORIZED_GA_USER;
  }

  const { cianUserId, userId } = user;

  return {
    type: lkType,
    cianUserId,
    userId,
  };
}
